var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center text-no-wrap",style:(_vm.disabled ? 'opacity: 0.2' : '')},[(_vm.icon)?_c('v-icon',{attrs:{"small":"","left":"","color":"grey"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('span',{class:_vm.cssclass},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }